var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "company-contact-wrapper" }, [
    _c(
      "ul",
      {
        staticClass: "accordion accordion-customize",
        attrs: {
          id: "company-contact-accordion",
          "data-accordion": "",
          "data-deep-link": "true",
          "data-allow-all-closed": "true",
          "data-multi-expand": "true",
          "data-update-history": "true",
          "data-deep-link-smudge": "500",
        },
      },
      [
        _c(
          "li",
          {
            staticClass: "accordion-item is-active",
            attrs: { "data-accordion-item": "" },
          },
          [
            _c("a", { staticClass: "accordion-title" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("company.titles.contact")))]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-content",
                attrs: { "data-tab-content": "" },
              },
              [
                _c("table", [
                  _c("thead", [
                    _c("tr", [
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("company.contactTable.name"))),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(_vm._s(_vm.$t("company.contactTable.title"))),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$t("company.contactTable.department"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$t("company.contactTable.propPeople"))
                        ),
                      ]),
                      _vm._v(" "),
                      _c("th"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    _vm._l(_vm.ccdcontacts, function (item, index) {
                      return _c("tr", { key: "company_contact_" + index }, [
                        _c("td", [
                          _c(
                            "a",
                            {
                              staticClass: "link",
                              on: {
                                click: function ($event) {
                                  return _vm.navTo("ccdContactView", {
                                    id: item.id,
                                  })
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(
                                    _vm.displayI18nFullName(
                                      item.firstName,
                                      item.lastName
                                    ) || item.name
                                  ) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.allowEdit
                            ? _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.deep(item, "CompanyContact.title"),
                                },
                                on: {
                                  change: function (event) {
                                    return _vm.updatePathField(
                                      item.id,
                                      "title",
                                      event.target.value
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.allowEdit
                            ? _c("div", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.deep(item, "CompanyContact.title")
                                    ) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _vm.allowEdit
                            ? _c("input", {
                                directives: [
                                  { name: "hkldinput", rawName: "v-hkldinput" },
                                ],
                                attrs: { type: "text" },
                                domProps: {
                                  value: _vm.deep(
                                    item,
                                    "CompanyContact.department"
                                  ),
                                },
                                on: {
                                  change: function (event) {
                                    return _vm.updatePathField(
                                      item.id,
                                      "department",
                                      event.target.value
                                    )
                                  },
                                },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.allowEdit
                            ? _c("div", [
                                _vm._v(
                                  "\n                  " +
                                    _vm._s(
                                      _vm.deep(
                                        item,
                                        "CompanyContact.department"
                                      )
                                    ) +
                                    "\n                "
                                ),
                              ])
                            : _vm._e(),
                        ]),
                        _vm._v(" "),
                        _c("td", [
                          _c("input", {
                            directives: [
                              { name: "hkldinput", rawName: "v-hkldinput" },
                            ],
                            attrs: {
                              id: "checkbox_" + index,
                              type: "checkbox",
                              disabled: !_vm.allowEdit,
                            },
                            domProps: {
                              checked: _vm.deep(
                                item,
                                "CompanyContact.isPropertyPerson"
                              )
                                ? "checked"
                                : "",
                            },
                            on: {
                              change: function ($event) {
                                _vm.updatePathField(
                                  item.id,
                                  "isPropertyPerson",
                                  !_vm.deep(
                                    item,
                                    "CompanyContact.isPropertyPerson"
                                  )
                                )
                              },
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "icon-remove" }, [
                          _vm.allowEdit && !_vm.canRemove(item)
                            ? _c("i", {
                                staticClass: "fa fa-times-thin",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeContact(item.id)
                                  },
                                },
                              })
                            : _vm._e(),
                        ]),
                      ])
                    }),
                    0
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn--orange",
                    on: {
                      click: function ($event) {
                        return _vm.navTo(
                          "contacts",
                          {},
                          {
                            companyId: _vm.currentCompany.id,
                            from: _vm.ccdRouteNames.companyEdit,
                          }
                        )
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("company.contactTable.linkContact")) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }